<template>
  <fragment>
 <div class="card m-b-30" v-if="notelist.length>0">
  <div class="card-header row">
            <div class="col-10">
          <h4 class="page-title">Note</h4>
            </div>
          
        </div>
        <div class="card-body">
    <div class="row" v-if="isloading">
      <div class="col-12 text-center">
      <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Caricamento in corso
      </div>
    </div>
    <div  class="row"  >
                                  
                                    <div  class="col-12"  v-for="(item,index) in notelist"
        :key="item.noteId" v-if="index<3">
                                        
                                         
                                              <h6 v-html="item.content.replace(/(?:\r\n|\r|\n)/g, '<br />')"></h6>
                                            <p class="mb-0 mt-2">Modificato il {{item.lastUpdate | formatDate}} da {{item.lastUpdateUser.firstName}} {{item.lastUpdateUser.lastName}}</p>
                                             
                                           
                                        </div>
                                        
                                    </div>
                                   
                               
     
        </div> 
 </div>
    
  </fragment>
</template>
<style scoped>
.attachment-filename {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
<script>
let vm_scope;
import axios from "axios";
export default {
  name: "noteinfo",

  props: {
    readOnly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: String,
      required: true,
    },
    entityType: {
      type: String,
      required: false,
      default: () => "company",
    },
    
  },
  components: {},
  data() {
    return {
      options: [],
      content:"",
      note: null,
      notelist: [],
     
      isloading:false
    };
  },
  mounted() {
    setTimeout(this.loaddata, 200);
  },
  methods: {
  addNote:function(){
this.note = {
  noteId:this.value,
  entityType : this.entityType,
  entityId : this.value,
  content : this.content
};
this.saveNote();

  },
  editNote:function(id){
this.note = {
  noteId:id,
 
}

  },
  saveNote :function(item){
var me = this;
if(item)
this.note = item;
axios.post("note",this.note).then((response) => {

                           me.loaddata();
                        });
  },
    removeNote:function(id){
      var me = this;
   this.$swal(
                    {
                        title: ``,
                        html: `Sicuri di voler eliminare la risorsa?`,
                        type: "question",
                        showCancelButton: true,
                        confirmButtonClass: "btn-warning-rgba",
                        confirmButtonText: "Procedi"
                    }

                ).then(function (isconfirm) {
                    if (isconfirm.value) {
                        axios.delete('note/' + id).then((response) => {

                           me.loaddata();
                        });
                    }
                });

    },
   
    save:function(){

var me = this;
      axios.put(`note`, this.note).then(function (result) {
me.attachment = null;
                   me.loaddata();
                });

return false;
    },
    loaddata: function () {
      this.content = "";
      this.note = null;
      var me = this;
this.isloading = true;
      axios
        .get(`note/list/${me.value}`)
        .then((response) => {
          me.notelist = response.data;
          me.isloading = false;
        });
    },
  },
};
</script>
